import type {ReactElement} from 'react';
import {useContext} from 'react';
import type {Editor} from 'grapesjs';
import {EmailMakerBlockManager} from '@Components/email-maker-block-manager/email-maker-block-manager';
import {emailMakerContext} from '@EmailMakerReact/email-maker-react.context';
import {isAiEditEnabled} from '@EmailMakerReact/lib/email-maker-ai-library';
import {EditorViewport} from '@EmailMakerReact/email-maker-react.types';
import {ScreenBreakpoints} from '@Libraries/responsiveness-library';
import {EMAIL_MAKER_BLOCKS} from '@EmailMakerReact/email-maker-react.constants';
import {useIsInVersionHistoryMode} from '@EmailMakerReact/hooks/use-is-in-version-history-mode';
import {BlockManagerSkeleton} from './components/block-manager-skeleton/block-manager-skeleton';
import styles from './email-maker-left-panel.module.scss';

/**
 * Desktop-only; the wrapper id lets the block manager's outside-click listener recognise clicks
 * inside this panel.
 */
export function EmailMakerLeftPanel(): ReactElement | null {
  const {editor, state} = useContext(emailMakerContext);
  const isHidden = useIsInVersionHistoryMode();

  if (state.editorViewport !== EditorViewport.DESKTOP) {
    return null;
  }

  return (
    <div id={EMAIL_MAKER_BLOCKS.ID_BLOCKS_MANAGER_CONTAINER} className={`${styles.panel} ${isHidden ? styles.hidden : ''}`}>
      {renderPanelContent(editor, state.isEditorLoading)}
    </div>
  );
}

function renderPanelContent(editor: Editor | null, isEditorLoading: boolean): ReactElement {
  if (!editor || isEditorLoading) {
    return <BlockManagerSkeleton />;
  }
  return <EmailMakerBlockManager gjsEditor={editor} getIsAiEditEnabled={(): boolean => isAiEditEnabled(editor)} mobileBreakpoint={ScreenBreakpoints.LARGE} />;
}
